export default __webpack_public_path__ + "static/media/notting_5.9e1f5d95.jpg";